import React from 'react';
import axios from 'helpers/axios';

import { Form, Container, Title, TextInput, Button, Label } from 'ui/components/styled';
import { useToasts } from 'hooks';

export const InviteUser = ({ onClose, onSuccess }) => {
  const [state, setState] = React.useState({ email: '' });
  const [preventSubmit, setPreventSubmit] = React.useState(false);
  const { errorToast, successToast, removeAllToasts } = useToasts();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((state) => ({ ...state, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setPreventSubmit(true);
      const response = await axios.post(`/uext/invite`, state);
      if (response.status === 200) {
        removeAllToasts();
        if (onClose) {
          onClose();
        }
        if (onSuccess) {
          onSuccess(state.email);
        } else {
          successToast('User invited!');
        }
        return;
      }
    } catch (error) {
      errorToast({ error, default: 'Error: Invite User.' });
    }
    setPreventSubmit(false);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Container mb="xs">
        <Title variant="darkGrey" fontWeight="500">
          Invite new user
        </Title>
      </Container>
      <Container mb="m">
        <Label htmlFor="email" mb="xs">
          Email
        </Label>
        <TextInput
          id="email"
          name="email"
          type="email"
          variant="minimal"
          placeholder="Email"
          value={state.email}
          onChange={handleChange}
          required
          autoFocus
        />
      </Container>
      <Container flexDirection="row" justifyContent="flex-end" mt="xxs">
        <Button
          variant="contrast-primary"
          width="30%"
          disabled={preventSubmit}
          onClick={onClose}
          boxShadow="none"
          mr="s"
        >
          Close
        </Button>
        <Button type="submit" width="30%" disabled={preventSubmit}>
          Invite
        </Button>
      </Container>
    </Form>
  );
};
